import App from './Components/index';


export function index() {
    return <App />
}

export default index;